export const EyeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="77" height="77" viewBox="0 0 77 77" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_914_595)">
        <path
          d="M38.5002 68.9788C55.3333 68.9788 68.9793 55.3329 68.9793 38.4997C68.9793 21.6665 55.3333 8.02051 38.5002 8.02051C21.667 8.02051 8.021 21.6665 8.021 38.4997C8.021 55.3329 21.667 68.9788 38.5002 68.9788Z"
          fill="#00C4B8"
        />
        <path
          d="M62.0846 36.3023C62.6525 36.8988 62.9692 37.6909 62.9692 38.5144C62.9692 39.338 62.6525 40.1301 62.0846 40.7266C58.2346 44.7723 49.1229 52.9503 38.5034 52.9503C27.8838 52.9503 18.7817 44.7723 14.9285 40.7266C14.3607 40.1301 14.0439 39.338 14.0439 38.5144C14.0439 37.6909 14.3607 36.8988 14.9285 36.3023C18.7785 32.2566 27.8838 24.0625 38.5002 24.0625C49.1165 24.0625 58.2314 32.2566 62.0846 36.3023Z"
          fill="white"
        />
        <path
          d="M16.7218 42.5168C21.2134 38.2433 29.2888 32.0833 38.4999 32.0833C47.7111 32.0833 55.7961 38.2433 60.2877 42.5168C60.9711 41.8752 61.5711 41.2592 62.0812 40.7266C62.6491 40.1301 62.9658 39.338 62.9658 38.5144C62.9658 37.6909 62.6491 36.8988 62.0812 36.3023C58.2312 32.2566 49.1227 24.0625 38.4999 24.0625C27.8772 24.0625 18.7751 32.2437 14.9251 36.2895C14.3572 36.886 14.0405 37.678 14.0405 38.5016C14.0405 39.3252 14.3572 40.1172 14.9251 40.7137C15.4384 41.2592 16.0416 41.8687 16.7218 42.5168Z"
          fill="white"
        />
        <path
          d="M62.0846 36.3023C62.6525 36.8988 62.9692 37.6909 62.9692 38.5144C62.9692 39.338 62.6525 40.1301 62.0846 40.7266C58.2346 44.7723 49.1229 52.9503 38.5034 52.9503C27.8838 52.9503 18.7817 44.7723 14.9285 40.7266C14.3607 40.1301 14.0439 39.338 14.0439 38.5144C14.0439 37.6909 14.3607 36.8988 14.9285 36.3023C18.7785 32.2566 27.8838 24.0625 38.5002 24.0625C49.1165 24.0625 58.2314 32.2566 62.0846 36.3023Z"
          stroke="#1E293B"
          strokeWidth="3.20833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.4998 46.5212C40.0862 46.5212 41.637 46.0508 42.956 45.1694C44.275 44.2881 45.303 43.0354 45.9101 41.5698C46.5172 40.1042 46.676 38.4914 46.3666 36.9355C46.0571 35.3797 45.2932 33.9505 44.1714 32.8287C43.0497 31.707 41.6205 30.9431 40.0646 30.6336C38.5087 30.3241 36.896 30.483 35.4304 31.09C33.9648 31.6971 32.7121 32.7252 31.8308 34.0442C30.9494 35.3632 30.479 36.914 30.479 38.5003C30.479 40.6276 31.3241 42.6677 32.8283 44.1719C34.3324 45.6761 36.3726 46.5212 38.4998 46.5212Z"
          fill="#00C4B8"
        />
        <path
          d="M44.1755 32.8403C42.6689 31.3472 40.6321 30.5117 38.5109 30.5166C36.3898 30.5216 34.3569 31.3665 32.8572 32.8667C31.3576 34.3668 30.5131 36.3998 30.5088 38.521C30.5045 40.6422 31.3405 42.6787 32.8341 44.1849L44.1755 32.8403Z"
          fill="#C4F0EB"
        />
        <path
          d="M38.4998 46.5212C40.0862 46.5212 41.637 46.0508 42.956 45.1694C44.275 44.2881 45.303 43.0354 45.9101 41.5698C46.5172 40.1042 46.676 38.4914 46.3666 36.9355C46.0571 35.3797 45.2932 33.9505 44.1714 32.8287C43.0497 31.707 41.6205 30.9431 40.0646 30.6336C38.5087 30.3241 36.896 30.483 35.4304 31.09C33.9648 31.6971 32.7121 32.7252 31.8308 34.0442C30.9494 35.3632 30.479 36.914 30.479 38.5003C30.479 40.6276 31.3241 42.6677 32.8283 44.1719C34.3324 45.6761 36.3726 46.5212 38.4998 46.5212V46.5212Z"
          stroke="#1E293B"
          strokeWidth="3.20833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M61.7734 9.8623C67.9128 14.8518 72.2859 21.6824 74.2474 29.3465"
          stroke="#1E293B"
          strokeWidth="3.20833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.5786 2.47649C38.3012 0.78255 46.3636 1.61252 53.5792 4.84424"
          stroke="#1E293B"
          strokeWidth="3.20833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.37061 22.2948C8.85021 15.1902 14.5212 9.39205 21.547 5.75586"
          stroke="#1E293B"
          strokeWidth="3.20833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.17825 54.3462C1.77944 47.2019 0.767152 39.1542 2.29075 31.3906"
          stroke="#1E293B"
          strokeWidth="3.20833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.1585 74.4591C22.4529 72.6661 15.5278 68.4438 10.4048 62.415"
          stroke="#1E293B"
          strokeWidth="3.20833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M61.4201 67.4199C55.2232 72.3384 47.6072 75.1306 39.6997 75.383"
          stroke="#1E293B"
          strokeWidth="3.20833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M75.3961 38.5771C75.3833 46.4882 72.8266 54.1853 68.1035 60.5318"
          stroke="#1E293B"
          strokeWidth="3.20833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_914_595">
          <rect width="77" height="77" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
